import { el } from 'redom';

import { stringToSVG } from 'utilities';

import addIconString from 'assets/images/add-icon.svg?raw';

import './index.scss';

const addIcon = stringToSVG(addIconString);

class ActionViewDefault {

  constructor() {

    this.icon = addIcon.cloneNode(true);
    this.label = el('label.ellipsis', 'Add new');

    this.el = el('.action-view-button', [this.icon, this.label]);

  }

  update(option) {

    let text = 'new';
    const userText = option.text.trim();

    if (userText !== '') {
      text = userText;
    }

    this.label.textContent = `Add ${text}`;

  }

}

class ActionsList {

  constructor(actions) {

    this.option = { text: '' };
    this.actions = actions || [];
    this.actionViews = [];

    this.el = el('.searchable-select-actions-list-main', this.renderActions());

  }

  renderActions() {

    const actions = this.actions;
    const actionViewContainers = [];
    const actionViews = this.actionViews;

    for (let action of actions) {

      const View = action.View || ActionViewDefault;
      const actionView = new View();
      const actionViewContainer = el('.searchable-select-action-view', {
        onclick: this.handleActionButtonClick.bind(this, action)
      }, [actionView]);

      actionViewContainers.push(actionViewContainer);
      actionViews.push(actionView);

    }

    this.actionViews = actionViews;

    return actionViewContainers;

  }

  update(option) {

    this.option = option;

    const actionViews = this.actionViews;

    for (let actionView of actionViews) {
      actionView.update(this.option);
    }

  }

  handleActionButtonClick(action) {

    action.onClick(this.option);

  }

}

export default ActionsList;